import * as Sentry from '@sentry/vue'
import type { RuntimeConfig } from 'nuxt/schema'
import { watch } from 'vue'
import { defineNuxtPlugin, useRuntimeConfig } from '#app'
import {
  applySentryUserSyncToSdk,
  attachSentryVueAppInstrumentation,
  fpSentryDefaultBeforeSend,
  getFpSentryVueInitOptions,
  registerSentryCspViolationReporter,
} from '../../member-webapp-shared/lib/nuxt/sentry-vue-client'
import { getSentryUserSyncResult } from '../../member-webapp-shared/lib/nuxt/sentry-user-from-auth'

// Taken from https://github.com/nuxt-community/sentry-module/issues/358#issuecomment-1016983543
export default defineNuxtPlugin((nuxtApp) => {
  const config: RuntimeConfig = useRuntimeConfig()
  const { vueApp } = nuxtApp

  Sentry.init(
    getFpSentryVueInitOptions(Sentry, {
      vueApp,
      dsn: config.public.sentryDsn,
      environment: config.public.environment,
      tunnel: config.public.sentryTunnel,
      beforeSend: fpSentryDefaultBeforeSend,
    })
  )

  registerSentryCspViolationReporter(Sentry, {
    dsn: config.public.sentryDsn,
  })

  attachSentryVueAppInstrumentation(Sentry, vueApp)

  const auth = useAuth()
  watch(
    () => [auth.status.value, auth.data.value?.user?.email] as const,
    ([status, email]) => {
      applySentryUserSyncToSdk(
        Sentry,
        getSentryUserSyncResult({ status, email })
      )
    },
    { immediate: true }
  )

  return {
    provide: {
      sentrySetContext: Sentry.setContext,
      sentrySetTag: Sentry.setTag,
      sentryAddBreadcrumb: Sentry.addBreadcrumb,
      sentryCaptureException: Sentry.captureException,
    },
  }
})
